import { render, staticRenderFns } from "./ColumnPinned.vue?vue&type=template&id=589f7656&"
import script from "./ColumnPinned.vue?vue&type=script&lang=js&"
export * from "./ColumnPinned.vue?vue&type=script&lang=js&"
import style0 from "./ColumnPinned.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports